import { Size } from './DataTable.types';

/**
 * Column ID used for the "select all" checkbox column.
 * Used to identify and style the selection column differently.
 */
export const SELECT_ALL_ROWS_ID = 'select-all-rows';

/**
 * Tailwind CSS height classes mapped to each Size variant.
 * - `sm`: 48px
 * - `md`: 64px
 * - `lg`: 96px
 */
export const SIZE_CLASSES: Record<Size, string> = {
  sm: 'h-12',
  md: 'h-16',
  lg: 'h-24'
};
